
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40.261","height":"26.802"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 722","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Path 6995","d":"M23.2 6.483h-6.137a.5.5 0 00-.5.5v6.137a.5.5 0 00.5.5H23.2a.5.5 0 00.5-.5V6.983a.5.5 0 00-.5-.5zm-.5 6.137h-5.142V7.475H22.7z"}}),_c('path',{attrs:{"data-name":"Path 6996","d":"M39.764 23.64h-.885v-1.6h.885a.5.5 0 000-1h-.885v-.94a.5.5 0 10-1 0v.94h-1.767v-.94a.5.5 0 00-1 0v.94h-1.769v-.94a.5.5 0 10-1 0v.94h-1.531v-9.512a.5.5 0 00-.04-.2l-2.5-5.82a.5.5 0 00-.227-.245l-7.418-3.869v-.9a.5.5 0 10-1 0v.9l-7.418 3.869a.5.5 0 00-.227.245l-2.5 5.82a.492.492 0 00-.041.2v9.512H7.899v-.94a.5.5 0 00-1 0v.94H5.13v-.94a.5.5 0 10-1 0v.94H2.361v-.94a.5.5 0 00-1 0v.94H.476a.5.5 0 000 1h.885v1.6H.476a.5.5 0 000 1h.885v1.437a.5.5 0 101 0v-1.442H4.13v1.437a.5.5 0 101 0v-1.437h1.769v1.437a.5.5 0 101 0v-1.437h1.542v1.669a.5.5 0 00.5.5h20.37a.5.5 0 00.5-.5v-1.669h1.542v1.437a.5.5 0 101 0v-1.437h1.769v1.437a.5.5 0 101 0v-1.437h1.769v1.437a.5.5 0 101 0v-1.437h.885a.5.5 0 000-1zm-35.617 0H2.378v-1.6h1.769zm2.764 0H5.142v-1.6h1.769zm2.537 0H7.906v-1.6h1.542zm9.946-1.85l-3.687 3.383v-6.765zm-2.906-4.017h7.285l-3.642 3.342zm0 8.034l3.642-3.342 3.642 3.342zm8.065-.634l-3.687-3.383 3.687-3.383zm5.264.634h-4.269v-8.532a.493.493 0 00-.027-.154c0-.007 0-.013-.006-.02a.492.492 0 00-.093-.153s0-.007-.006-.009h-.005a.5.5 0 00-.146-.106l-.013-.008a.5.5 0 00-.168-.04h-9.906a.5.5 0 00-.168.04l-.013.007a.5.5 0 00-.147.107s0 .007-.006.009a.5.5 0 00-.092.153l-.006.02a.493.493 0 00-.027.154v8.531H10.45V11.631l2.389-5.563 7.3-3.806 7.3 3.806 2.389 5.563zm2.537-2.167h-1.542v-1.6h1.542zm2.764 0h-1.769v-1.6h1.769zm2.764 0h-1.77v-1.6h1.769z"}})])])
          )
        }
      }
    